<template>
  <div class="page-writing-center">
    <component :is="stateComponent" />
  </div>
</template>
<script>
import './index.less';
export default {
  name: 'WritingCenter',
  components: {
    Introduction: () => import('./Introduction'),
    Part1: () => import('./Part1'),
    Part2: () => import('./Part2')
  },
  provide() {
    return {
      root: this
    };
  },
  computed: {
    stateComponent() {
      let ret = '';
      switch (true) {
        case /introduction/i.test(this.state): {
          ret = 'Introduction';
          break;
        }
        case /part1/i.test(this.state): {
          ret = 'Part1';
          break;
        }
        case /part2/i.test(this.state): {
          ret = 'Part2';
          break;
        }
        default: {
          ret = 'Introduction';
          break;
        }
      }
      return ret;
    },
    isPart1Open() {
      return false;
    },
    isPart2Open() {
      return true;
      // return this.$time.isOverDate('2022-07-19 00:00:00');
    }
  },
  data: () => ({
    state: ''
  }),
  async created() {
    await this.$minusPermission().then(async () => {
      await this.setInitData();
    });
  },
  methods: {
    async setInitData() {
      let state = this.$route.params.state;
      this.state = state;
    },
    setState(state) {
      this.state = state;
    }
  }
};
</script>
